<mat-form-field appearance="outline" subscriptSizing="dynamic">
  <mat-label>Sage item code</mat-label>
  <input
    formControlName="sageItemCode"
    type="text"
    matInput
    autocomplete="off"
    placeholder="e.g. MBP-FG-101"
  >
  <mat-hint>{{ helper }}</mat-hint>
</mat-form-field>
@if (sageItemIdText) {
  <p class="sage-item-id-readonly">Sage item id: {{ sageItemIdText }}</p>
}
